import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../redux/axios';

const initialState = {
    AllCollaborateData: [],
    collaborateCount: 0,
    isFetching: false,
    isAllCollaborateSuccess: false,
    isError: false,
    errorMessage: '',
};


export const DeleteProcessAsyn = (bdata) => async (dispatch, getState) => {
    const { auth } = getState()
    let tokenStr = auth.user.token;
    const response = await axios.post('/api/clerk/deleteCollaboration', bdata, { headers: { "Authorization": `Bearer ${tokenStr}` } });
  
    let data = response.data;
    console.log(data.data)
    // dispatch(setAddState(data));
    return data;
  };

export const getAllCollaborateDoc = createAsyncThunk(
    'clerk/collaboratedDoc/',
    async (udata, thunkAPI) => {
        try {
            const { auth } = thunkAPI.getState()
            let tokenStr = auth.user.token;
            let response = await axios({
                url: `/api/clerk/collaboratedDoc?limit=10${udata}`,
                method: 'get',
                //timeout: 8000,
                headers: {
                    //'Content-Type': 'application/json',
                    "Authorization": `Bearer ${tokenStr}`
                }
            })

            let data = response.data;
            if (response.status === 200) {
                return data;
            }
            else if (data.code === 200) {
                return data;
            }
            else {
                return thunkAPI.rejectWithValue(data);
            }
        } catch (err) {
            if (!err.response) {
                throw err
            }

            return thunkAPI.rejectWithValue(err.response.data)
        }
    }
);


export const ClerkCollaborateDocSlice = createSlice({
    name: 'clerkCollaborateDoc',
    initialState,
    // The `reducers` field lets us define reducers and generate associated actions
    reducers: {
        clearStateCollaborateDoc: (state, { payload }) => {
            state.AllCollaborateData = [];
            // state.isFetching = false;
            state.isAllCollaborateSuccess = false;
            state.isError = false;
            state.errorMessage = '';
        },
    },
    // The `extraReducers` field lets the slice handle actions defined elsewhere,
    // including actions generated by createAsyncThunk or in other slices.
    extraReducers: {
        [getAllCollaborateDoc.fulfilled]: (state, { payload }) => {

            state.AllCollaborateData = payload.data;
            state.collaborateCount = payload.data.count;
            state.isFetching = false;
            state.isAllCollaborateSuccess = true;
            return state;
        },
        [getAllCollaborateDoc.pending]: (state) => {
            state.isFetching = false;
        },
        [getAllCollaborateDoc.rejected]: (state, { payload }) => {
            state.isFetching = false;
            state.isError = true;
            if (payload) {
                state.errorMessage = payload.message;
            }
            else {
                state.errorMessage = 'Internal error';
            }
        }
    },
});


export const { clearStateCollaborateDoc } = ClerkCollaborateDocSlice.actions;

export function clearState() {

    return async (dispatch) => {
        dispatch(clearStateCollaborateDoc());
    }
}

export const clerkCollaborateDocSelector = (state) => state.clerkCollaborateDoc;

export default ClerkCollaborateDocSlice.reducer;
